export enum Phase {
  SETUP = 'SETUP',
  PRODUCTION = 'PRODUCTION',
  PLANNING = 'PLANNING',
  WAR = 'WAR',
  RESOLUTION = 'RESOLUTION',
  TRIBUTE = 'TRIBUTE',
}

export function getPhaseName(phase: Phase) {
  return PhaseToName[phase];
}

// TODO: rename to TurnPhaseOrder to allow for age setup phase
export const PhaseOrder = [
  Phase.SETUP,
  Phase.PRODUCTION,
  Phase.PLANNING,
  Phase.WAR,
  Phase.RESOLUTION,
  Phase.TRIBUTE,
] as const;

export function getPhaseOrder() {
  return PhaseOrder;
}
export function nextPhase(phase: Phase) {
  var index = PhaseOrder.indexOf(phase);
  var new_index = (index + 1) % PhaseOrder.length;
  return PhaseOrder[new_index];
}

export const PhaseToName: Record<Phase, string> = {
  SETUP: 'Setup',
  PRODUCTION: 'Production',
  PLANNING: 'Planning',
  WAR: 'War',
  RESOLUTION: 'Resolution',
  TRIBUTE: 'Tribute',
};
